/**
 * Historial de una orden o de un pedido de movilidad (2026-10-07): qué pasó,
 * quién y cuándo. Se carga al abrirlo.
 */
import { rec_React as React, rec_api as api } from "../../runtime/index.jsx";

// runtime/index.jsx importa este archivo antes de definir React (import circular).
const useState = (...a) => React.useState(...a);

const ACCIONES = {
  CREADA: `Creada`,
  AGRUPADA: `Agrupada`,
  CERRADA: `Cerrada`,
  CANCELADA: `Cancelada`,
};

const cuando = (v) => (v ? new Date(v).toLocaleString(`es-PE`, { day: `2-digit`, month: `short`, hour: `2-digit`, minute: `2-digit` }) : ``);

export function HistorialTransporte({ de, id }) {
  const [abierto, setAbierto] = useState(false);
  const [pasos, setPasos] = useState(null);
  const [error, setError] = useState(``);

  const alternar = async () => {
    const abrir = !abierto;
    setAbierto(abrir);
    if (abrir && pasos == null) {
      try {
        setPasos(await api(`/transporte/${de === `orden` ? `ordenes` : `pedidos`}/${id}/historial`, { sinCache: true }));
      } catch (e) {
        setError(e.message);
      }
    }
  };

  return (
    <div className="text-xs">
      <button type="button" onClick={alternar} className="text-(--accent) hover:underline">
        {abierto ? `Ocultar historial` : `Ver historial`}
      </button>
      {abierto && (
        <ol className="mt-1.5 flex flex-col gap-1 border-l-2 border-(--border) pl-3">
          {error && <li className="text-(--error)">{error}</li>}
          {!error && pasos == null && <li className="text-(--text)">Cargando…</li>}
          {(pasos ?? []).map((p, i) => (
            <li key={i} className="text-(--text)">
              <span className="text-(--text-h)">{cuando(p.en)}</span> · <strong className="text-(--text-h)">{ACCIONES[p.accion] ?? p.accion}</strong>
              {p.actor && <> · {p.actor}</>}
              {p.detalle && <div>{p.detalle}</div>}
            </li>
          ))}
          {pasos && !pasos.length && <li className="text-(--text)">Sin movimientos registrados.</li>}
        </ol>
      )}
    </div>
  );
}
